import { RaceEntry } from '../models/RaceEntry.js';
export function parseCSV(text) {
  if (text.length > 250000) throw new Error('Choose a CSV smaller than 250 KB.');
  const rows = []; let row = [], value = '', quoted = false;
  text = text.replace(/^\uFEFF/, '');
  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    if (char === '"') {
      if (quoted && text[i + 1] === '"') { value += '"'; i++; }
      else quoted = !quoted;
    } else if (!quoted && (char === ',' || char === '\n' || char === '\r')) {
      row.push(value.trim()); value = '';
      if (char !== ',') { if (row.some(Boolean)) rows.push(row); row = []; if (char === '\r' && text[i + 1] === '\n') i++; }
    } else value += char;
  }
  if (quoted) throw new Error('A quoted field is not closed. Check the CSV.');
  row.push(value.trim()); if (row.some(Boolean)) rows.push(row);
  return rows;
}
export function raceFingerprint(race) {
  return [race.raceName?.trim().toLowerCase(), race.date || '', Number(race.distance)].join('|');
}
export function reviewImport(text, existing = []) {
  const [headers, ...rows] = parseCSV(text);
  if (!headers || !['raceName', 'distance'].every(h => headers.includes(h))) throw new Error('CSV needs raceName and distance columns (distance in kilometres).');
  if (rows.length > 200) throw new Error('Import at most 200 races at a time.');
  const seen = new Set(existing.map(raceFingerprint));
  return rows.map((values, index) => {
    const data = Object.fromEntries(headers.map((key, i) => [key, values[i] || '']));
    const race = new RaceEntry({ raceName: data.raceName, distance: Number(data.distance), time: data.time || null,
      date: data.date || null, location: data.location || null, type: data.type || 'road',
      elevation: data.elevation ? Number(data.elevation) : null, notes: data.notes || null,
      resultsLink: data.resultsLink || null, isTimed: data.isTimed !== 'false', isHighlighted: true });
    const errors = RaceEntry.validate(race).errors;
    if (race.resultsLink && !/^https?:\/\//i.test(race.resultsLink)) errors.push('Results link must use http(s)');
    const key = raceFingerprint(race); const duplicate = seen.has(key);
    if (!errors.length) seen.add(key);
    return { row: index + 2, race, errors, duplicate };
  });
}
